import { BASE_URL } from "../environment";
import makeRequest from "../makeRequest";

export default async function reserveVodafoneAppointment({
  productCode,
  addressReference,
  accessLineId,
  districtCode,
  appointmentDate,
  appointmentStartTime,
  appointmentEndTime,
}) {
  return makeRequest(`${BASE_URL}/vodafonereserveappointment`, {
    method: "POST",
    body: JSON.stringify({
      productCode,
      addressReference,
      accessLineId,
      districtCode,
      appointmentDate,
      appointmentStartTime,
      appointmentEndTime,
    }),
    headers: { "Content-Type": "application/json" },
  });
}
